module.exports = __webpack_public_path__ + "static/media/uoa-10.5fe92be6.jpg";